import { render } from "./AuthAppHeaderBar.vue?vue&type=template&id=a2445d98&scoped=true&ts=true"
import script from "./AuthAppHeaderBar.vue?vue&type=script&lang=ts"
export * from "./AuthAppHeaderBar.vue?vue&type=script&lang=ts"

import "./AuthAppHeaderBar.vue?vue&type=style&index=0&id=a2445d98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2445d98"]])

export default __exports__